export default __webpack_public_path__ + "static/large-cabin-living-bd51cfc7b45985f6cdc5f61c33b7ec76.jpg";